module.exports = __webpack_public_path__ + "img/icon-download.bf08a0e4.svg";